// Centralized, typed access to build-time env (Vite exposes VITE_* to the client).
// Anything read here is PUBLIC in the shipped bundle — never put real prod secrets
// in VITE_* vars. See VITE_DEV_DB_TOKEN warning below.

export const env = {
  /**
   * Base URL of the published per-project browser-safe config (served via
   * CloudFront), e.g. https://app.sidenerd.app/config. The app fetches
   * `${base}/${project_string}.ui.json`. Unset => use the bundled sample offline.
   */
  configBaseUrl: import.meta.env.VITE_CONFIG_BASE_URL,
  /** DatabaseAPI base URL (API Gateway). Unset => no live data (sample fallback). */
  databaseApiUrl: import.meta.env.VITE_DATABASE_API_URL,
  /**
   * DEV ONLY interim token for local reads against the DEV DatabaseAPI. Must never
   * be set in the production build — prod authenticates end users via Cognito and
   * the DatabaseAPI validates the JWT (Phase 2).
   */
  devDbToken: import.meta.env.VITE_DEV_DB_TOKEN,
  /** twilio-invite lambda Function URL (outbound SMS invites). Unset => invite UI hidden. */
  inviteUrl: import.meta.env.VITE_INVITE_URL,
  /** Stripe customer-portal login link (no-code) for billing contacts. */
  billingPortalUrl: import.meta.env.VITE_BILLING_PORTAL_URL,
  /**
   * OAuth credential broker Function URL (SideNerdApps lambdas/sidenerd_oauth).
   * Unset => the Connections view shows a not-available notice. The browser only
   * ever hits its `start` (redirect) and `status` (boolean) actions — token
   * custody stays server-side.
   */
  oauthBrokerUrl: import.meta.env.VITE_OAUTH_BROKER_URL,
  /**
   * Signed-in in-app chat endpoint (full .../{stage}/app-chat URL, see
   * lib/webchat/appChatTransport.ts). Unset => the "Try it" tab keeps the
   * public demo-key chat.
   */
  appChatUrl: import.meta.env.VITE_APP_CHAT_URL,
  cognito: {
    userPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID,
    clientId: import.meta.env.VITE_COGNITO_CLIENT_ID,
    region: import.meta.env.VITE_COGNITO_REGION ?? "us-east-1",
  },
} as const;
